/* Refund-acknowledgment gate.
 * For each [data-refund-ack] block, find the closest checkout button(s)
 * (cart drawer footer button, cart page checkout button, dynamic checkout
 * buttons rendered by Shopify) and disable them until the checkbox is
 * ticked. Re-runs on cart updates (Refine emits 'theme:cart:updated').
 */
(function () {
  'use strict';

  function findCheckoutTargets(ackEl) {
    var targets = [];
    var ctx = ackEl.getAttribute('data-context') || 'drawer';
    var scope;
    if (ctx === 'drawer') {
      scope = ackEl.closest('cart-drawer') || ackEl.closest('.cart-drawer') || document;
    } else {
      scope = ackEl.closest('main') || document;
    }
    // Native checkout buttons in the form sibling
    scope.querySelectorAll(
      'button[name="checkout"], .cart-drawer-footer-button, .cart-button-checkout'
    ).forEach(function (b) { targets.push(b); });
    // Dynamic checkout buttons (Shop Pay, PayPal, etc.) rendered by Shopify
    scope.querySelectorAll(
      '.shopify-payment-button button, .additional-checkout-buttons button, [data-shopify=payment-button] button'
    ).forEach(function (b) { targets.push(b); });
    return targets;
  }

  function setLocked(ackEl, locked) {
    var targets = findCheckoutTargets(ackEl);
    targets.forEach(function (t) {
      if (locked) {
        t.setAttribute('aria-disabled', 'true');
        t.classList.add('is-refund-locked');
      } else {
        t.removeAttribute('aria-disabled');
        t.classList.remove('is-refund-locked');
      }
    });
  }

  function persistAttribute(value) {
    /* Write to Shopify cart attribute. On checkout, this becomes
     * order note_attributes.refund_ack — read by the dashboard. */
    try {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { refund_ack: value ? 'true' : '' } })
      });
    } catch (e) { /* gate UX is the primary defense; swallow */ }
  }

  function bind(ackEl) {
    if (ackEl.__refundAckBound) return;
    ackEl.__refundAckBound = true;
    var input = ackEl.querySelector('[data-refund-ack-input]');
    var error = ackEl.querySelector('[data-refund-ack-error]');
    if (!input) return;

    setLocked(ackEl, !input.checked);

    input.addEventListener('change', function () {
      setLocked(ackEl, !input.checked);
      if (input.checked && error) error.hidden = true;
      persistAttribute(input.checked);
      /* Sync sibling checkboxes (drawer + page) on the same DOM */
      document.querySelectorAll('[data-refund-ack-input]').forEach(function (peer) {
        if (peer !== input) {
          peer.checked = input.checked;
          var peerEl = peer.closest('[data-refund-ack]');
          if (peerEl) setLocked(peerEl, !input.checked);
        }
      });
    });

    var targets = findCheckoutTargets(ackEl);
    targets.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (input.checked) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (error) error.hidden = false;
        ackEl.classList.add('refund-ack--shake');
        setTimeout(function () { ackEl.classList.remove('refund-ack--shake'); }, 500);
        try { input.focus(); } catch (err) {}
      }, true);
    });
  }

  function boot() {
    document.querySelectorAll('[data-refund-ack]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('theme:cart:updated', boot);
  document.addEventListener('cart:refresh', boot);
})();
